<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "1.5rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24"><path fill-rule="evenodd" d="M19.299 11.876a7.423 7.423 0 11-14.846 0 7.423 7.423 0 0114.846 0zm-8.014 2.234h-1.06v-1.052H8.07v-.894L9.317 9.1h1.175l-1.212 3h.944v-1.081h1.06V12.1h.533v.959h-.533v1.052zm4.768-3.827l-1.296 1.808 1.274 1.913h-1.267l-.66-.99-.602.99H12.29l1.237-1.85-1.237-1.871h1.27l.642.97.654-.97h1.197z"/></svg>